import React from "react";
import { compose, withHandlers } from "recompose";
import { LocalForm, Control, actions } from "react-redux-form";
import moment from "moment";
import {
  Page,
  onMount,
  FormGroup,
  DatePicker,
  required,
  SubmitButton,
} from "components/common";
import { ReportContainer } from "./components";
import { withDefaultReportParams } from "./hooks/useDefaultReportParams";
import { Trans } from "react-i18next";

export const TrialBalance = ({ data, item, handleSubmit, setState }) => (
  <Page>
    <div className="disc">
      <h4><Trans>Trail Balance without movement</Trans></h4>
      <p className="muted"></p>
    </div>
    <LocalForm
      className="d-print-none"
      getDispatch={(dispatch) => setState({ dispatch })}
      onSubmit={handleSubmit}
      initialState={item}
      validators={{
        date: { required },
      }}
    >
      <div className="d-flex align-items-center">
        <FormGroup label="Date" className="mr-3">
          <DatePicker model=".date" className="form-control" />
        </FormGroup>
        <FormGroup label="&nbsp;" className="mr-3">
          <FormGroup label="Cash transactions only" check>
            <Control.checkbox model=".paymentsOnly" />
          </FormGroup>
        </FormGroup>
        <FormGroup label="&nbsp;">
          <SubmitButton size="sm" className="d-block">
            Update
          </SubmitButton>
        </FormGroup>
      </div>
    </LocalForm>
    {data && <ReportContainer report={data} />}

  </Page>
);

const loadReport = (item, xero) =>
  xero.get("reports/TrialBalance", {
    params: {
      extra_params: item,
    },
  }).get("data");

export const enhance = compose(
  withDefaultReportParams(() => ({
    date: moment().format("YYYY-MM-DD"),
  })),
  onMount(({ xero, item }) => () => {
    return Promise.props({
      data: null,
      item,
    });
  }),
  withHandlers({
    handleSubmit:
      ({ setState, xero, dispatch, setReportParams }) =>
      (item) => {
        setReportParams(item);
        return loadReport(item, xero)
          .then((data) => setState({ data }))
          .finally(() => dispatch(actions.setSubmitted("local", true)));
      },
  })
);

export default enhance(TrialBalance);
